(function () {
    'use strict';

    angular
        .module('app')
        /* @ngInject */
        .constant('CATEGORIA_WEB_FORM_ADMIN', function (modal) {
            var resolve = "$resolve.";
            if (modal) {
                resolve = "ctrl.resolve."
            }
            return {
                component: '<categoria-web-form-admin ' +
                'item="' + resolve + 'item" ' +
                'previous-params="' + resolve + 'previousParams"' +
                '></categoria-web-form-admin>',
                resolve: {
                    /* @ngInject */
                    item: function (CategoriaWeb) {
                        return new CategoriaWeb();
                    }
                }
            }
        });
})();
